import React, { Fragment } from "react";

const EmployerProfileApprovals = () => {
  return (
    <Fragment>
      <div className="online-users-profile">
        <div className="online-title-container-alt">
          <div className="border-alt blue">
            <p className="online-title-alt blue">
              <i className="fas fa-file-signature blue mr-5"></i>Approvals
            </p>
          </div>
        </div>
        <div className="online-user red">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border red">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="red name-font">User Name</span>
                </li>
                <li className="side-container-user-item">User Job Title</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user red">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border red">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="red name-font">User Name</span>
                </li>
                <li className="side-container-user-item">User Job Title</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user red">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border red">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="red name-font">User Name</span>
                </li>
                <li className="side-container-user-item">User Job Title</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user red">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border red">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="red name-font">User Name</span>
                </li>
                <li className="side-container-user-item">User Job Title</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user red">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border red">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="red name-font">User Name</span>
                </li>
                <li className="side-container-user-item">User Job Title</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user red">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border red">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="red name-font">User Name</span>
                </li>
                <li className="side-container-user-item">User Job Title</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user red">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border red">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="red name-font">User Name</span>
                </li>
                <li className="side-container-user-item">User Job Title</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user red">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border red">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="red name-font">User Name</span>
                </li>
                <li className="side-container-user-item">User Job Title</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
        <div className="online-user red">
          <div className="flex-only">
            <div className="online-avi-container">
              <div className="avi-color-border red">
                <div className="drop-down-result-avi"></div>
              </div>
            </div>
            <div className="online-info">
              <ul className="user-online-items">
                <li className="user-online-item">
                  <span className="red name-font">User Name</span>
                </li>
                <li className="side-container-user-item">User Job Title</li>
                <li className="side-container-user-item">Location</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default EmployerProfileApprovals;
